var defaultBehavior = function (props) { return ({
    attributes: {
        root: {},
    },
}); };
export default defaultBehavior;
